<div class="wrapper">
  <div class="content" [style.paddingTop]="'20px'">
    @if (document) {
      <pdf-viewer class="pdf-viewer" [src]="document"></pdf-viewer>
    }
  </div>
</div>
